/* eslint react/prop-types: off */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect } from 'react'
import { FormInput, Button, Popup, FormInputText, Select } from 'camino-react'

import { filter, find, isEmpty, map, sortBy } from 'lodash'

import { cloudhelpGet } from 'Utilities/CloudHelp'

const Participants = ({ report, setReport, canEdit }) => {
  const [participants, setParticipants] = useState([])
  const [modalOpen, openModal] = useState(false)
  const [newParticipant, setNewParticipant] = useState({ })
  const [clientOptions, setClientOptions] = useState([])
  const [usersOptions, setUsersOptions] = useState([])

  const fetchClients = () => {
    cloudhelpGet('/api/clients?as_options=true')
      .then(({ data }) => setClientOptions(sortBy(data, 'label')))
  }

  const fetchUsers = () => {
    cloudhelpGet(`/api/clients/${newParticipant.clientId}/users`)
      .then(({ data }) => setUsersOptions(
        sortBy(map(data, user => ({ value: user.id, label: user.name })), 'label')
      ))
  }

  useEffect(() => setParticipants(report.participants), [report.participants])
  useEffect(() => fetchClients(), [])
  useEffect(() => fetchUsers(), [newParticipant.clientId])

  const deleteParticipant = (id) => {
    setParticipants(
      prevParticipants => (filter(prevParticipants, prevPart => (prevPart.id !== id)))
    )
    setReport({ ...report, participants: filter(participants, prevPart => (prevPart.id !== id)) })
  }

  const updateParticipants = () => {
    setParticipants(prevParticipants => ([...prevParticipants, newParticipant]))
    setReport({ ...report, participants: [...participants, newParticipant] })
    openModal(false)
  }

  return (
    <div className="mb-4">
      <FormInput>
        <table className="">
          <tr className="bg-gray-50">
            <td className="border border-gray-200 p-2 w-1/2">Name</td>
            <td className="border border-gray-200 p-2">Company</td>
            <td className="border border-gray-200 p-2">Role</td>
            {canEdit && (
              <td className="border border-gray-200 p-2 text-center">
                <span
                  className="lnr lnr-plus-circle text-green-500 align-middle hover:text-green-700 text-3xl"
                  onClick={() => openModal(true)}
                />
              </td>
            )}
          </tr>
          {map(participants, ({ id, name, client, role }, index) => (
            <tr className={index % 2 && 'bg-gray-50'} key={name}>
              <td className="border border-gray-200 p-2 w-1/2">{name}</td>
              <td className="border border-gray-200 p-2">{client}</td>
              <td className="border border-gray-200 p-2">{role}</td>
              {canEdit && (
                <td className="border border-gray-200 p-2 text-center">
                  <span className="lnr lnr-trash2 lnr-red mt-2 mb-2" onClick={() => deleteParticipant(id)} />
                </td>
              )}
            </tr>
          ))
          }
        </table>
        <Popup modal open={modalOpen} closeOnDocumentClick={false}>
          <div className="text-gray-600 p-10">
            <div className="flex justify-between mb-10">
              <h3 className="m-0 font-medium">New participant</h3>
            </div>

            <FormInput label="Company">
              <Select
                onChange={({ value, label }) => setNewParticipant(participant => ({ ...participant, clientId: value, client: label, id: null }))}
                options={clientOptions}
                isLoading={isEmpty(clientOptions)}
                value={find(clientOptions, ['value', newParticipant.clientId])}
              />
            </FormInput>
            <FormInput label="User">
              <Select
                onChange={({ value, label }) => setNewParticipant(participant => ({ ...participant, id: value, name: label }))}
                options={usersOptions}
                isLoading={isEmpty(usersOptions)}
                value={find(usersOptions, ['value', newParticipant.id])}
              />
            </FormInput>
            <FormInput label="Role">
              <FormInputText
                value={newParticipant.role}
                onValue={value => setNewParticipant(participant => ({ ...participant, role: value }))}
              />
            </FormInput>

            <div className="flex justify-center mt-8">
              <Button outline onClick={() => openModal(false)}>Cancel</Button>
              <div className="mr-4" />
              <Button onClick={() => updateParticipants()}>
                Save
              </Button>
            </div>
          </div>
        </Popup>

      </FormInput>
    </div>
  )
}

export default Participants
